import React, { useState, useEffect } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoiceAgent from "./InvoiceAgent/Invoice";

const PricingForm = (props) => {
  const sortedData = props?.selectedDataMain.sort((a, b) => {
    // pick the correct date field depending on item type
    const dateA = new Date(a.serviceDate);
    const dateB = new Date(b.serviceDate);

    const diff = dateA - dateB;
    if (diff !== 0) return diff;

    if (a.profileactivity === "Accommodations" && b.profileactivity !== "Accommodations") {
      return -1;
    }
    if (b.profileactivity === "Accommodations" && a.profileactivity !== "Accommodations") {
      return 1;
    }
    return 0;
  });

  // State for the form inputs
  const [formState, setFormState] = useState({
    priceOption: "priceOption1",
    markupPrice: "",
    totalPriceOption: "totalPrice1",
    hideBrandingLogo: false,
  });
  const [error, setError] = useState("");
 
  // useEffect(() => {

  // }, [props?.selectedDataMain]);
  // Handle change for all inputs
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "markupPrice") {
      const numericValue = Number(value);
      if (numericValue < 0 || numericValue > 100) {
        setError("Markup percentage must be between 0 and 100.");
      } else {
        setError(""); // Clear error if valid
      }
    }
    setFormState((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (error) {
      alert("Please fix the errors before submitting.");
      return;
    }
  };

  const TotalPrice = sortedData.reduce(
    (amount, item) => parseFloat(item.totalamountincluded) + amount,
    0
  );

  const TotalPriceAll = sortedData.reduce(
    (amount, item) => parseFloat(item.totalAmount) + amount,
    0
  );
  console.log(sortedData)
  
  const TaxandFee = 0;
  let TotalPriceInclude = TaxandFee + TotalPrice;
  let OfferPrice = (TotalPriceAll-TotalPriceInclude);
  let JsonStatePDFData = {
    booking_amount: TotalPriceInclude,
    total_main_amount:TotalPriceAll,
     offer_discount: OfferPrice,
    numberof_night: 2,
    agentdetails: props?.customerDetails?.agent,
    child: sortedData,
    markupdata: formState
  };

  const propertypdf = JSON.stringify(
    JsonStatePDFData
  );
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
         
            <fieldset>
              
              <label style={{marginBottom:'10px'}}>Do you want to customize this quotation?</label>
          
              <div className="container">
                <div className="row align-items-start">
                  <div className="form-check col">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="priceOption"
                      id="priceOption1"
                      value="priceOption1"
                      checked={formState.priceOption === "priceOption1"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="priceOption1">
                      No
                    </label>
                  </div>
                  <div className="form-check col">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="priceOption"
                      id="priceOption2"
                      value="priceOption2"
                      checked={formState.priceOption === "priceOption2"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="priceOption2">
                      Yes
                    </label>
                  </div>
                </div>
              </div>
             {formState.priceOption === "priceOption2" &&(<>
              <label style={{marginBottom: 10, marginTop:5}}>Add desired markup percentage</label>
              <div className="col-md-6">
                <div className="input-group has-validation">
                  <span className="input-group-text" id="inputGroupPrepend" style={{height: '34px'}}>
                    Markup
                  </span>
                  <input style={{height: '34px'}}
                    type="number"
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    id="markupPrice"
                    name="markupPrice"
                    placeholder="Add Markup %"
                    value={formState.markupPrice}
                    onChange={handleChange}
                  />

                  {error && <div className="invalid-feedback">{error}</div>}
                </div>
              </div></>)}
              
            </fieldset>

            {formState.priceOption === "priceOption2" &&(<><fieldset>
              <label style={{marginTop:15, marginBottom: 10}}>Hide individual line-item prices, show only the total</label>
             
              <div className="container">
                <div className="row align-items-start">
                  <div className="form-check col">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="totalPriceOption"
                      id="totalPrice1"
                      value="totalPrice1"
                      checked={formState.totalPriceOption === "totalPrice1"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="totalPrice1">
                      No
                    </label>
                  </div>
                  <div className="form-check col">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="totalPriceOption"
                      id="totalPrice2"
                      value="totalPrice2"
                      checked={formState.totalPriceOption === "totalPrice2"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="totalPrice2">
                      Yes
                    </label>
                  </div>
                </div>
              </div>
            </fieldset></>)}

            <fieldset>
              <div className="container" style={{marginTop:5, marginBottom:5}}>
                <div className="row align-items-start">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="brandingLogo"
                      name="hideBrandingLogo"
                      checked={formState.hideBrandingLogo}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="brandingLogo">
                      Hide Holidays Seychelles logo
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>

         <div>
          {formState.priceOption === "priceOption2" && formState.markupPrice !='' && error =='' ? (<PDFDownloadLink
            document={
              <InvoiceAgent
              invoice={
                propertypdf != null && propertypdf
              }
              />
            }
            fileName="Quotation.pdf"
            style={{
              fontSize:
                "15px",
              color:
                "#ff0000",
              fontWeight:
                "500",
            }}
          >
            {({
              blob,
              url,
              loading,
              error,
            }) =>
              loading
                ? "Loading document..."
                : "Download Quotation"
            }
          </PDFDownloadLink>):(formState.priceOption === "priceOption1" &&(<PDFDownloadLink
            document={
              <InvoiceAgent
              invoice={
                propertypdf != null && propertypdf
              }
              />
            }
            fileName="Quotation.pdf"
            style={{
              fontSize:
                "15px",
              color:
                "#ff0000",
              fontWeight:
                "500",
            }}
          >
            {({
              blob,
              url,
              loading,
              error,
            }) =>
              loading
                ? "Loading document..."
                : "Download Quotation"
            }
          </PDFDownloadLink>))
        }
        </div>
        </div>
      </div>
    </div>
  );
};

export default PricingForm;
